export const findUser = (email) => {
    const array = [
        'adela.avdic@carynhealth.com',
        'balaji.narayana@carynhealth.com',
    ];
    return array.includes(email);
};